import type { MixedCabinPillProps } from "@b2bportal/core-flights/overridable";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { isMixedCabin } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./styles.module.scss";

const COMPONENT_KEY = CoreFlightsComponent.MixedCabinPill;

export const MixedCabinPill = ({
  fareSlice,
  className,
}: MixedCabinPillProps) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  if (!isMixedCabin(fareSlice)) {
    return null;
  }

  return <span className={clsx(block, className)}>{t("mixedCabin.icon")}</span>;
};
